<template>
  <div class="panel-reservas">
    <!-- Barra de dia -->
    <div class="barra-dia">
      <v-btn
        icon
        variant="text"
        size="small"
        title="Dia anterior"
        @click="moverDia(-1)"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <div class="selector-dia">
        <v-text-field
          v-model="fecha"
          type="date"
          class="fg-blue"
          variant="outlined"
          density="compact"
          hide-details
        />
        <div class="etiqueta-dia">
          {{ etiquetaDia }}
        </div>
      </div>

      <v-btn
        icon
        variant="text"
        size="small"
        title="Dia siguiente"
        @click="moverDia(1)"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>

      <v-btn
        v-if="!esHoy"
        variant="tonal"
        size="small"
        color="primary"
        @click="irAHoy"
      >
        Hoy
      </v-btn>
    </div>

    <!-- Resumen del dia -->
    <div class="resumen">
      <div class="dato-resumen">
        <div class="numero-resumen">
          {{ resumen.pending }}
        </div>
        <div class="etiqueta-resumen">
          Pendientes
        </div>
      </div>
      <div class="dato-resumen">
        <div class="numero-resumen confirmadas">
          {{ resumen.confirmed }}
        </div>
        <div class="etiqueta-resumen">
          Confirmadas
        </div>
      </div>
      <div class="dato-resumen">
        <div class="numero-resumen">
          {{ resumen.fulfilled }}
        </div>
        <div class="etiqueta-resumen">
          Cumplidas
        </div>
      </div>
      <div class="dato-resumen">
        <div class="numero-resumen personas">
          {{ resumen.people }}
        </div>
        <div class="etiqueta-resumen">
          Personas
        </div>
      </div>
    </div>

    <!-- Acciones -->
    <div class="acciones-panel">
      <v-btn
        color="primary"
        size="small"
        @click="abrirNuevaReserva"
      >
        <v-icon start>
          mdi-plus
        </v-icon>
        Nueva reserva
      </v-btn>
      <v-btn
        variant="tonal"
        size="small"
        @click="dialogMesas = true"
      >
        <v-icon start>
          mdi-table-furniture
        </v-icon>
        Mesas ({{ mesas.length }})
      </v-btn>
    </div>

    <!-- Filtro por estado -->
    <div class="filtros">
      <v-chip
        v-for="opcion in opcionesEstado"
        :key="opcion.valor || 'todas'"
        :color="filtroEstado === opcion.valor ? 'primary' : undefined"
        :variant="filtroEstado === opcion.valor ? 'flat' : 'outlined'"
        size="small"
        class="chip-filtro"
        @click="cambiarFiltro(opcion.valor)"
      >
        {{ opcion.titulo }}
      </v-chip>
    </div>

    <v-alert
      v-if="error"
      type="error"
      density="compact"
      class="mb-3"
      closable
      @click:close="error = ''"
    >
      {{ error }}
    </v-alert>

    <!-- Listado -->
    <div
      v-if="cargando"
      class="estado-vacio"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        size="30"
      />
    </div>

    <div
      v-else-if="reservas.length === 0"
      class="estado-vacio"
    >
      <v-icon
        size="34"
        color="grey-lighten-1"
      >
        mdi-calendar-blank
      </v-icon>
      <div class="mt-2">
        No hay reservas para este dia
      </div>
    </div>

    <div
      v-else
      class="lista-reservas"
    >
      <div
        v-for="reserva in reservas"
        :key="reserva.idReservation"
        class="tarjeta-reserva"
        :class="'estado-' + reserva.state"
      >
        <div class="hora">
          {{ soloHora(reserva.reservationDate) }}
        </div>

        <div class="cuerpo-reserva">
          <div class="linea-cliente">
            <span class="nombre-cliente">{{ reserva.customerName }}</span>
            <v-chip
              :color="colorEstado(reserva.state)"
              size="x-small"
              variant="flat"
            >
              {{ reserva.state }}
            </v-chip>
          </div>

          <div class="linea-detalles">
            <span>
              <v-icon size="13">mdi-account-group</v-icon>
              {{ reserva.people }}
            </span>
            <span v-if="reserva.tableName">
              <v-icon size="13">mdi-table-furniture</v-icon>
              {{ reserva.tableName }}
            </span>
            <span
              v-else
              class="sin-mesa"
            >
              <v-icon size="13">mdi-help-circle-outline</v-icon>
              Sin mesa
            </span>
            <a
              v-if="reserva.customerPhone"
              :href="'tel:' + reserva.customerPhone"
              class="telefono"
            >
              <v-icon size="13">mdi-phone</v-icon>
              {{ reserva.customerPhone }}
            </a>
          </div>

          <div
            v-if="reserva.note"
            class="nota"
          >
            {{ reserva.note }}
          </div>

          <div class="botones-reserva">
            <v-btn
              v-for="accion in accionesDe(reserva)"
              :key="accion.estado"
              :color="accion.color"
              variant="tonal"
              size="x-small"
              @click="cambiarEstado(reserva, accion.estado)"
            >
              <v-icon
                start
                size="14"
              >
                {{ accion.icono }}
              </v-icon>
              {{ accion.titulo }}
            </v-btn>

            <v-spacer />

            <v-btn
              icon
              variant="text"
              size="x-small"
              title="Editar"
              @click="abrirEdicion(reserva)"
            >
              <v-icon size="17">
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-btn
              icon
              variant="text"
              size="x-small"
              color="red"
              title="Eliminar"
              @click="pedirConfirmacionBorrado(reserva)"
            >
              <v-icon size="17">
                mdi-delete
              </v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <v-pagination
      v-if="totalPaginas > 1"
      v-model="pagina"
      :length="totalPaginas"
      density="compact"
      class="mt-2"
      @update:modelValue="cambiarPagina"
    />

    <!-- Dialogos -->
    <v-dialog
      v-model="dialogReserva"
      max-width="700"
    >
      <DialogReserva
        v-if="dialogReserva"
        :id-empresa="idEmpresa"
        :reserva="reservaEnEdicion"
        :mesas="mesas"
        :fecha-por-defecto="fecha"
        @onClose="dialogReserva = false"
        @alGuardar="alGuardarReserva"
      />
    </v-dialog>

    <v-dialog
      v-model="dialogMesas"
      max-width="700"
    >
      <DialogMesas
        v-if="dialogMesas"
        :id-empresa="idEmpresa"
        @onClose="dialogMesas = false"
        @alCambiarMesas="cargarMesas"
      />
    </v-dialog>

    <v-dialog
      v-model="dialogBorrado"
      max-width="420"
    >
      <v-card>
        <v-card-title class="titulo-modal">
          Eliminar reserva
        </v-card-title>
        <v-card-text>
          Se va a eliminar la reserva de
          <strong>{{ reservaPorBorrar ? reservaPorBorrar.customerName : '' }}</strong>.
          Esta accion no se puede deshacer.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            variant="text"
            @click="dialogBorrado = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="red"
            variant="tonal"
            @click="confirmarBorrado"
          >
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :timeout="2500"
      color="success"
    >
      {{ mensajeSnackbar }}
    </v-snackbar>
  </div>
</template>

<script>
import apisReservas from '@/apis/apisReservas'
import DialogReserva from './DialogReserva.vue'
import DialogMesas from './DialogMesas.vue'

const RESUMEN_VACIO = {
  total: 0,
  pending: 0,
  confirmed: 0,
  fulfilled: 0,
  cancelled: 0,
  people: 0
}

function fechaDeHoy() {
  const hoy = new Date()
  const mes = String(hoy.getMonth() + 1).padStart(2, '0')
  const dia = String(hoy.getDate()).padStart(2, '0')

  return `${hoy.getFullYear()}-${mes}-${dia}`
}

export default {
  name: 'PanelReservas',
  components: { DialogReserva, DialogMesas },
  props: {
    idEmpresa: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      fecha: fechaDeHoy(),
      filtroEstado: null,
      reservas: [],
      mesas: [],
      resumen: Object.assign({}, RESUMEN_VACIO),
      // v-pagination es base 1, el backend base 0
      pagina: 1,
      totalPaginas: 0,
      cargando: false,
      error: '',
      dialogReserva: false,
      dialogMesas: false,
      dialogBorrado: false,
      reservaEnEdicion: null,
      reservaPorBorrar: null,
      snackbar: false,
      mensajeSnackbar: '',
      opcionesEstado: [
        { titulo: 'Todas', valor: null },
        { titulo: 'Pendientes', valor: 'pendiente' },
        { titulo: 'Confirmadas', valor: 'confirmada' },
        { titulo: 'Cumplidas', valor: 'cumplida' },
        { titulo: 'Canceladas', valor: 'cancelada' }
      ]
    }
  },
  computed: {
    esHoy() {
      return this.fecha === fechaDeHoy()
    },
    etiquetaDia() {
      if (!this.fecha) {
        return ''
      }
      // Se construye con partes locales: new Date('YYYY-MM-DD') se interpreta
      // como UTC y en Colombia mostraria el dia anterior.
      const partes = this.fecha.split('-')
      const dia = new Date(Number(partes[0]), Number(partes[1]) - 1, Number(partes[2]))

      return dia.toLocaleDateString('es-CO', {
        weekday: 'long',
        day: 'numeric',
        month: 'long'
      })
    }
  },
  watch: {
    fecha() {
      this.pagina = 1
      this.cargarTodo()
    }
  },
  created() {
    this.cargarMesas()
    this.cargarTodo()
  },
  methods: {
    cargarTodo() {
      this.cargarReservas()
      this.cargarResumen()
    },
    cargarReservas() {
      this.cargando = true
      this.error = ''

      apisReservas.listarReservas(this.idEmpresa, this.fecha, this.filtroEstado, this.pagina - 1)
        .then(pagina => {
          this.reservas = pagina.content
          this.totalPaginas = pagina.totalPages
          this.pagina = pagina.pageNumber + 1
        })
        .catch(error => {
          this.error = error.message
        })
        .finally(() => {
          this.cargando = false
        })
    },
    cargarResumen() {
      apisReservas.resumenReservas(this.idEmpresa, this.fecha)
        .then(resumen => {
          this.resumen = resumen
        })
        .catch(() => {
          // El resumen es informativo: si falla no vale la pena tapar la lista
          this.resumen = Object.assign({}, RESUMEN_VACIO)
        })
    },
    cargarMesas() {
      apisReservas.listarMesas(this.idEmpresa)
        .then(mesas => {
          this.mesas = mesas
        })
        .catch(error => {
          this.error = error.message
        })
    },
    moverDia(dias) {
      const partes = this.fecha.split('-')
      const dia = new Date(Number(partes[0]), Number(partes[1]) - 1, Number(partes[2]))

      dia.setDate(dia.getDate() + dias)

      const mes = String(dia.getMonth() + 1).padStart(2, '0')
      const numeroDia = String(dia.getDate()).padStart(2, '0')

      this.fecha = `${dia.getFullYear()}-${mes}-${numeroDia}`
    },
    irAHoy() {
      this.fecha = fechaDeHoy()
    },
    cambiarFiltro(estado) {
      this.filtroEstado = estado
      this.pagina = 1
      this.cargarReservas()
    },
    cambiarPagina(pagina) {
      this.pagina = pagina
      this.cargarReservas()
    },
    abrirNuevaReserva() {
      this.reservaEnEdicion = null
      this.dialogReserva = true
    },
    abrirEdicion(reserva) {
      this.reservaEnEdicion = reserva
      this.dialogReserva = true
    },
    alGuardarReserva() {
      this.dialogReserva = false
      this.avisar('Reserva guardada')
      this.cargarTodo()
    },
    cambiarEstado(reserva, estado) {
      this.error = ''

      apisReservas.cambiarEstadoReserva(reserva.idReservation, estado)
        .then(() => {
          this.avisar('Reserva ' + estado)
          this.cargarTodo()
        })
        .catch(error => {
          this.error = error.message
        })
    },
    pedirConfirmacionBorrado(reserva) {
      this.reservaPorBorrar = reserva
      this.dialogBorrado = true
    },
    confirmarBorrado() {
      const reserva = this.reservaPorBorrar

      this.dialogBorrado = false

      apisReservas.eliminarReserva(reserva.idReservation)
        .then(() => {
          this.avisar('Reserva eliminada')
          this.cargarTodo()
        })
        .catch(error => {
          this.error = error.message
        })
    },
    /** Acciones rapidas segun el estado actual de la reserva. */
    accionesDe(reserva) {
      if (reserva.state === 'pendiente') {
        return [
          { estado: 'confirmada', titulo: 'Confirmar', icono: 'mdi-check', color: 'green' },
          { estado: 'cancelada', titulo: 'Cancelar', icono: 'mdi-close', color: 'grey' }
        ]
      }
      if (reserva.state === 'confirmada') {
        return [
          { estado: 'cumplida', titulo: 'Llego', icono: 'mdi-check-all', color: 'blue' },
          { estado: 'cancelada', titulo: 'Cancelar', icono: 'mdi-close', color: 'grey' }
        ]
      }
      if (reserva.state === 'cancelada') {
        return [
          { estado: 'pendiente', titulo: 'Reactivar', icono: 'mdi-restore', color: 'orange' }
        ]
      }
      return []
    },
    colorEstado(estado) {
      if (estado === 'pendiente') return 'orange'
      if (estado === 'confirmada') return 'green'
      if (estado === 'cumplida') return 'blue'
      return 'grey'
    },
    soloHora(fechaHora) {
      if (!fechaHora) {
        return ''
      }
      const partes = fechaHora.split('T')

      return partes[1] ? partes[1].substring(0, 5) : ''
    },
    avisar(mensaje) {
      this.mensajeSnackbar = mensaje
      this.snackbar = true
    }
  }
}
</script>

<style scoped>
.panel-reservas {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.barra-dia {
  display: flex;
  align-items: center;
  gap: 6px;
}
.selector-dia {
  flex: 1;
  min-width: 0;
}
.etiqueta-dia {
  font-size: 0.75rem;
  color: #777;
  text-transform: capitalize;
  margin-top: 2px;
  text-align: center;
}
.resumen {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
}
.dato-resumen {
  background: #f7f9fc;
  border: 1px solid #e3e8ef;
  border-radius: 8px;
  padding: 8px 4px;
  text-align: center;
}
.numero-resumen {
  font-size: 1.15rem;
  font-weight: 700;
  color: #e08600;
  line-height: 1.1;
}
.numero-resumen.confirmadas {
  color: #2e7d32;
}
.numero-resumen.personas {
  color: #1976d2;
}
.etiqueta-resumen {
  font-size: 0.65rem;
  color: #777;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.acciones-panel {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.filtros {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding-bottom: 2px;
}
.chip-filtro {
  cursor: pointer;
  flex-shrink: 0;
}
.lista-reservas {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.tarjeta-reserva {
  display: flex;
  gap: 10px;
  border: 1px solid #e3e8ef;
  border-left: 4px solid #bdbdbd;
  border-radius: 8px;
  padding: 10px;
}
.tarjeta-reserva.estado-pendiente {
  border-left-color: #fb8c00;
}
.tarjeta-reserva.estado-confirmada {
  border-left-color: #2e7d32;
}
.tarjeta-reserva.estado-cumplida {
  border-left-color: #1976d2;
}
.tarjeta-reserva.estado-cancelada {
  opacity: 0.6;
}
.hora {
  font-size: 1rem;
  font-weight: 700;
  color: #333;
  min-width: 46px;
  flex-shrink: 0;
}
.cuerpo-reserva {
  flex: 1;
  min-width: 0;
}
.linea-cliente {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.nombre-cliente {
  font-weight: 600;
  font-size: 0.92rem;
}
.linea-detalles {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 0.78rem;
  color: #777;
  margin-top: 2px;
}
.sin-mesa {
  color: #b08000;
}
.telefono {
  color: #1976d2;
  text-decoration: none;
}
.nota {
  font-size: 0.78rem;
  color: #555;
  background: #f7f9fc;
  border-radius: 6px;
  padding: 4px 8px;
  margin-top: 5px;
}
.botones-reserva {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 8px;
  flex-wrap: wrap;
}
.estado-vacio {
  text-align: center;
  color: #999;
  font-size: 0.85rem;
  padding: 30px 0;
}
.titulo-modal {
  font-size: 1rem;
  font-weight: 700;
}
</style>
